import Vue from "vue";
import App from "./App.vue";
import "whatwg-fetch";
import "promise-polyfill/src/polyfill";

Vue.config.productionTip = false;

const initApp = () => {
  new Vue({
    render: h => h(App)
  }).$mount("#app");
};
initApp();
